import moment from 'moment-timezone';
import qs from 'qs';
import {
  TAGS_REQUEST,
  TAGS_FAILURE,
  TAGS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function tagsRequest() {
  return {
    type: TAGS_REQUEST,
  };
}

function tagsSuccess(type, data, token = null) {
  return {
    type: TAGS_SUCCESS,
    payload: {
      type,
      data,
      token,
    },
  };
}

function tagsError(message) {
  return {
    type: TAGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchTags(tagType, fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(tagsRequest());
    if (!fresh) {
      let tagsData = {};
      try {
        tagsData = JSON.parse(getItem(`${config.get('appName')}.tags.${tagType}`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !tagsData.data ||
        config.get('version') !== tagsData.version ||
        moment().isAfter(moment(tagsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(tagsSuccess(tagType, tagsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/tags/${tagType}/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.tags.${tagType}`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(tagsSuccess(tagType, data, token));
      })
      .catch(err => dispatch(handleError(err, tagsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/tags.js